import React, { useCallback, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleModal } from 'apps/auth/actions/appAction';
import { toggleChat } from 'apps/auth/actions/chatAction';
import { updateExtraByName } from 'apps/auth/actions/extraAction';
import { changeFieldProperty, setFieldError, updateFields, updateFormProperties } from 'apps/auth/actions/formAction';
import { updatePageMessages } from 'apps/auth/actions/messageAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import BasePage from 'apps/auth/components/utils/BasePage';
import ModalNew from 'apps/auth/components/utils/ModalNew';
import NewSmsConfirmation from 'apps/auth/components/utils/NewSmsConfirmation/NewSmsConfirmation';
import SmsConfirmation from 'apps/auth/components/utils/SmsConfirmation';
import {
    ADRESS_SCREEN_CONTINUE_CLICKED,
    EMAIL_SCREEN_CONTINUE_CLICKED,
    ERROR_SCREEN_SHOWN,
    PERSONAL_INFO_SCREEN_CONTINUE_CLICKED,
} from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { FLOW } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { SIGNUP_AMPLITUDE } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { ERROR, ERROR_TOAST, USER_UUID } from 'apps/auth/constants/Constants';
import { SMS_CONFIRMATION } from 'apps/auth/constants/ExtraNames';
import { POST_CODE } from 'apps/auth/constants/fieldsName';
import { LOGIN_REGISTRATION_FORM_NAME } from 'apps/auth/constants/formName';
import { LOGIN, PAYSEND_URL } from 'apps/auth/constants/UrlConstants';
import { CANADA, UNITED_ARAB_EMIRATES, USA } from 'apps/auth/constants/WellKnownCountries';
import { getLangCountryPrefix, UUID } from 'apps/auth/helpers/utils';
import { useApp, useExtra, usePageMessages } from 'apps/auth/hooks/selectors';
import { useDynamicHeightButton } from 'apps/auth/hooks/useDynamicHeightButton';
import Cookies from 'universal-cookie';

import BirthdayCheck from './BirthdayCheck';
import {
    BIRTHDAY_CHECK,
    CANCEL_REASON_PASSCODE_SCREEN,
    DISCLAIMER_SCREEN,
    FILL_PROFILE_SCREEN,
    INSERT_PASSWORD,
    INSERT_PHONE_SCREEN,
    MIGRATION_PS_30_SCREEN,
    NEW_USER,
    PASSCODE_SCREEN,
    RESTORE_PASSWORD_SCREEN,
    SIMPLE_REGISTRATION,
    SMS_CONFIRMATION_SCREEN,
    WAITING_LIST,
} from './constants';
import Disclaimer from './Disclaimer';
import FillProfile from './FillProfile';
import InsertPasscode from './InsertPasscode';
import InsertPassword from './InsertPassword';
import InsertPhone from './InsertPhone';
import CanceledWebPinSetupModal from './modals/CanceledWebPinSetupModal';
import RestorePassword from './RestorePassword';
import { getForms, handleBackFlow, switchScreen } from './utils';
import VerifyDetailsModal from './VerifyDetailsModal';
import WaitingList from './WaitingList';

const RegistrationLogin = (props) => {
    const {
        simpleRegistration,
        redirectUrl,
        authType,
        showDisclaimer,
        canSendMoneyByCardFromUserCountry,
        showWaitingListDisclaimer,
        restorePassword,
        smsConfirmation,
        phoneCountryId,
        fieldForFirstScreen,
        fieldForSecondScreen,
        fieldForThirdScreen,
        createPasscode,
        showFeedbackCancellationReasons,
        authViaPasscode,
        showPreparedPs3MigrationScreen,
        showMigrationChat,
    } = useExtra();
    const [, updateState] = useState();
    const [screen, setScreen] = useState(showPreparedPs3MigrationScreen ? MIGRATION_PS_30_SCREEN : authViaPasscode ? PASSCODE_SCREEN : INSERT_PHONE_SCREEN);
    const [isBackFlow, setIsBackFlow] = useState(false);
    const [backUrl, setBackUrl] = useState();
    const [lastFormattedNumber, setLastFormattedNumber] = useState('');
    const popupRef = useRef(null);
    const modalRef = useRef(null);
    const {
        headerInfo,
        custom_title,
        headerTitleName,
        headerTitleAddress,
        headerTitleEmail,
        headerGrayTitleName,
        headerGrayTitleAddress,
        headerGrayTitleEmail,
        termsDisclaimerText,
        verifyDetailsTitle,
        verifyDetailsText,
        notNowButton,
        buttonContinue,
        preparingBetaTitle,
        gotIt,
        contactSupport,
        preparingBetaSubtitle,
    } = usePageMessages();
    const { messageBody } = useApp();

    const forceUpdate = useCallback(() => updateState({}), []);
    const fillProfileFormMessages = {
        headerTitleName,
        headerTitleAddress,
        headerTitleEmail,
        headerGrayTitleName,
        headerGrayTitleAddress,
        headerGrayTitleEmail,
    };
    const fieldsForScreens = [fieldForFirstScreen, fieldForSecondScreen, fieldForThirdScreen];
    const countriesWithDisclaimer = phoneCountryId === USA || phoneCountryId === CANADA;
    const isSingleInputScreen = screen === INSERT_PHONE_SCREEN || (simpleRegistration && screen === SIMPLE_REGISTRATION);
    const buttonPosition = useDynamicHeightButton(isSingleInputScreen);

    useEffect(() => {
        const cookies = new Cookies();
        const uuid = cookies.get(USER_UUID);
        if (!uuid) {
            const expirationDate = new Date();
            expirationDate.setFullYear(expirationDate.getFullYear() + 1);
            cookies.set(USER_UUID, UUID(), { path: '/', expires: expirationDate });
        }
    }, []);

    useEffect(() => {
        if (screen === INSERT_PHONE_SCREEN || (screen === PASSCODE_SCREEN && authViaPasscode)) {
            setBackUrl(`${PAYSEND_URL}${getLangCountryPrefix(props.lang, props.country)}`);
        } else if (screen === BIRTHDAY_CHECK) {
            openVerifyDetailsModal();
        } else {
            setBackUrl(LOGIN);
        }
    }, [screen]);

    useEffect(() => {
        if (messageBody?.length) {
            const errorCodeArr = [];
            const errorTypeArr = [];
            messageBody
                .filter((m) => m?.messageType === ERROR || m?.messageType === ERROR_TOAST)
                .forEach((m) => {
                    errorCodeArr.push('' + (m.errorCode ?? 'none'));
                    errorTypeArr.push('' + (m.errorCodeType ?? 'none'));
                });
            amplitude.getInstance().logEvent(ERROR_SCREEN_SHOWN, { error: errorCodeArr, error_type: errorTypeArr });
        }
    }, [messageBody]);

    useEffect(() => {
        const newScreen = switchScreen(screen, isBackFlow, authType, showDisclaimer, showWaitingListDisclaimer, restorePassword, simpleRegistration);
        setScreen(newScreen);
        setIsBackFlow(false);
    }, [authType]);

    useEffect(() => {
        if (smsConfirmation && smsConfirmation.objectType === 'VERIFY_KNOW_USER_INFO') {
            setScreen(BIRTHDAY_CHECK);
        } else if (smsConfirmation) {
            setScreen(SMS_CONFIRMATION_SCREEN);
        }
    }, [smsConfirmation]);

    useEffect(() => {
        if (!simpleRegistration && showDisclaimer && props.action === '/registration.action' && countriesWithDisclaimer) {
            setScreen(DISCLAIMER_SCREEN);
        }
    }, [props.action]);

    useEffect(() => {
        if (restorePassword) {
            setScreen(RESTORE_PASSWORD_SCREEN);
        }
    }, [restorePassword]);

    useEffect(() => {
        if (showWaitingListDisclaimer) {
            setScreen(WAITING_LIST);
        }
    }, [showWaitingListDisclaimer]);

    const submitHandlerFillProfile = (fields, json) => {
        const formName = LOGIN_REGISTRATION_FORM_NAME;
        const form = json.forms?.[formName];
        if (form?.action) {
            props.updateFormProperties(formName, form.action);
        }
        Object.values(fields).forEach((f) => {
            if (f.visible) {
                if (f.name === 'name') {
                    amplitude.getInstance().logEvent(PERSONAL_INFO_SCREEN_CONTINUE_CLICKED);
                } else if (f.name === 'address' || f.name === 'address2') {
                    if (f.name === 'address') {
                        amplitude.getInstance().logEvent(ADRESS_SCREEN_CONTINUE_CLICKED, {
                            [FLOW]: SIGNUP_AMPLITUDE,
                        });
                    }
                } else if (f.name === 'email') {
                    amplitude.getInstance().logEvent(EMAIL_SCREEN_CONTINUE_CLICKED);
                }
            }
        });
        if (form?.fields && !json.extra?.backendDidNotResponseForTransliteration) {
            const newFields = { ...props.fields };
            Object.values(form.fields).forEach((field) => {
                const newField = newFields[field.name];
                if (newField) {
                    if (field.name === POST_CODE && phoneCountryId === UNITED_ARAB_EMIRATES) {
                        newField.visible = false;
                        newField.mandatory = false;
                    } else {
                        newField.visible = field.visible;
                    }
                    newField.isReadOnly = field.isReadOnly;
                }
                newFields[field.name] = newField;
            });
            props.updateFields(formName, newFields).then(() => {
                if (!json.extra?.[SMS_CONFIRMATION]) {
                    forceUpdate();
                }
            });
        }

        if (form?.errors) {
            Object.keys(form.errors).forEach((name) => {
                props.setFieldError(formName, name, form.errors[name]);
            });
        }
        if (props.onSubmitHandler) {
            props.onSubmitHandler(fields, json);
        }
    };

    const onBackIconClick = (e) => {
        if (screen === INSERT_PHONE_SCREEN || (screen === PASSCODE_SCREEN && authViaPasscode)) {
            return;
        }
        if (screen === BIRTHDAY_CHECK) {
            e.preventDefault();
            openVerifyDetailsModal();
        }

        e.preventDefault();
        setIsBackFlow(true);
        const newScreen = handleBackFlow(
            authType,
            screen,
            showDisclaimer,
            termsDisclaimerText,
            showWaitingListDisclaimer,
            props.action,
            phoneCountryId,
            props.updateFormProperties,
            props.updateExtraByName,
            props.changeFieldProperty,
            props.updatePageMessages,
            fillProfileFormMessages,
            props.fields,
            canSendMoneyByCardFromUserCountry,
            fieldsForScreens,
            restorePassword,
            countriesWithDisclaimer,
            simpleRegistration,
            createPasscode,
            showFeedbackCancellationReasons,
            redirectUrl,
        );
        setScreen(newScreen);
    };

    const getFillProfileForms = () => {
        getForms(
            props.action,
            props.changeFieldProperty,
            props.updatePageMessages,
            props.updateFormProperties,
            fillProfileFormMessages,
            props.fields,
            fieldsForScreens,
        );
    };
    const getSmsConfirmationComponent = () => {
        const props = {
            isRegistration: authType === NEW_USER,
            redirectUrl: redirectUrl,
            smsConfirmation: smsConfirmation,
            headerText: custom_title,
            setScreen: setScreen,
        };
        if (smsConfirmation?.newSmsCodeEnabled) {
            return <NewSmsConfirmation {...props} smsLength={6} popupRef={popupRef} formattedNumber={lastFormattedNumber} />;
        } else {
            return <SmsConfirmation {...props} smsLength={5} formattedNumber={lastFormattedNumber} />;
        }
    };

    const openVerifyDetailsModal = () => {
        modalRef.current?.open(
            <VerifyDetailsModal
                popupRef={popupRef}
                modalRef={modalRef}
                title={verifyDetailsTitle}
                text={verifyDetailsText}
                buttonContinue={buttonContinue}
                notNowButton={notNowButton}
            />,
        );
    };

    const setFormattedNumber = (formattedValue) => {
        if (formattedValue) {
            setLastFormattedNumber(formattedValue);
        }
    };

    if (screen === WAITING_LIST) {
        return (
            <>
                <WaitingList
                    fromWaitingList={true}
                    screen={screen}
                    showDisclaimer={true}
                    formName={LOGIN_REGISTRATION_FORM_NAME}
                    onBackIconClick={onBackIconClick}
                    getFillProfileForms={getFillProfileForms}
                    popupRef={popupRef}
                />
                <PopupNew ref={popupRef} />
            </>
        );
    } else {
        return (
            <>
                <CommonPage
                    leftCloseIcon={screen === PASSCODE_SCREEN && createPasscode}
                    backUrl={backUrl}
                    isTagA
                    onClickIcon={onBackIconClick}
                    hasBottomPanel={screen === DISCLAIMER_SCREEN || screen === FILL_PROFILE_SCREEN || screen === SIMPLE_REGISTRATION}
                >
                    {screen === MIGRATION_PS_30_SCREEN && (
                        <InfoPage
                            insideModalComponent
                            iconName="clock-80"
                            iconColor="primary"
                            primaryButtonCaption={showMigrationChat ? contactSupport : gotIt}
                            headerText={preparingBetaTitle}
                            secondaryText={<DangerouslyHtml dangerouslyHtml={preparingBetaSubtitle} />}
                            primaryButtonOnClick={(e) => {
                                e.preventDefault();
                                if (showMigrationChat) {
                                    props.toggleChat(true);
                                } else {
                                    props.toggleModal(false);
                                }
                            }}
                        />
                    )}
                    {screen === DISCLAIMER_SCREEN && (
                        <Disclaimer
                            formName={LOGIN_REGISTRATION_FORM_NAME}
                            getCanonicalPath={true}
                            setScreen={setScreen}
                            onBackIconClick={onBackIconClick}
                            popupRef={popupRef}
                        />
                    )}
                    {screen === INSERT_PHONE_SCREEN && (
                        <InsertPhone
                            formName={LOGIN_REGISTRATION_FORM_NAME}
                            setScreen={setScreen}
                            popupRef={popupRef}
                            buttonPosition={buttonPosition}
                            formattedNumber={lastFormattedNumber}
                            setFormattedNumber={setFormattedNumber}
                        />
                    )}
                    {screen === INSERT_PASSWORD && (
                        <InsertPassword formName={LOGIN_REGISTRATION_FORM_NAME} headerInfo={headerInfo} popupRef={popupRef} setScreen={setScreen} />
                    )}
                    {screen === RESTORE_PASSWORD_SCREEN && <RestorePassword formName={LOGIN_REGISTRATION_FORM_NAME} />}
                    {screen === BIRTHDAY_CHECK && <BirthdayCheck formName={SMS_CONFIRMATION} setScreen={setScreen} />}
                    {(screen === FILL_PROFILE_SCREEN || screen === SIMPLE_REGISTRATION) && (
                        <FillProfile
                            getCanonicalPath={true}
                            headerInfo={headerInfo}
                            formName={LOGIN_REGISTRATION_FORM_NAME}
                            submitHandler={submitHandlerFillProfile}
                            getFillProfileForms={getFillProfileForms}
                            setScreen={setScreen}
                            popupRef={popupRef}
                            buttonPosition={buttonPosition}
                        />
                    )}
                    {screen === SMS_CONFIRMATION_SCREEN && getSmsConfirmationComponent()}
                    {screen === PASSCODE_SCREEN && <InsertPasscode maxLength={5} popupRef={popupRef} setScreen={setScreen} />}
                    {screen === CANCEL_REASON_PASSCODE_SCREEN && <CanceledWebPinSetupModal />}
                </CommonPage>
                <PopupNew ref={popupRef} />
                <ModalNew ref={modalRef} />
            </>
        );
    }
};

const mapStateToProps = ({ form, app, language, login }) => ({
    fields: form[LOGIN_REGISTRATION_FORM_NAME]?.fields,
    action: form[LOGIN_REGISTRATION_FORM_NAME]?.action,
    lang: language?.lang,
    country: app?.country,
    loginCountryCode: login.countryCode,
});

export default connect(mapStateToProps, {
    updateExtraByName,
    updatePageMessages,
    updateFields,
    updateFormProperties,
    changeFieldProperty,
    setFieldError,
    toggleModal,
    toggleChat,
})(BasePage(RegistrationLogin));
